import { CurrentReservationService } from '@/common/services/reservation/current';
import { isLiteReservation } from '@/common/utils/flow/type-flow.util';
import { isValid } from '@/common/utils/validation/common.utils';
import { Summary } from '@/core/domain/summary/models/summary.models';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SummaryService {
    constructor(private readonly reservation: CurrentReservationService) {}

    private _summary!: Summary | undefined;
    public get summary(): Summary | undefined {
        return this._summary;
    }
    public set summary(v: Summary | undefined) {
        this._summary = v;
    }

    public get isLite(): boolean {
        if (!this._summary || this.reservation.current?.origin === 'INT') {
            return false;
        }
        return isLiteReservation(
            this._summary.typeFlow,
            isValid(this._summary.insurance?.id) ? 1 : 0,
        );
    }
}
